export const LS = {
  RefreshToken: "refresh_token",
  PreviousPage: "previousPage",
  Cookies: "cookies",
  CookiesVersion: "cookiesVersion",
};

export const ApiErrorCode = {
  Unauthorized: 401,
  Forbidden: 403,
};

export const AbortError = "CanceledError";

export const PAGINATION_SIZE = 10;

export const EMPTY = "-";

/** The app serves the US: numbers, dates and times read the same in every browser. */
export const APP_LOCALE = "en-US";

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB

export const CURRENT_COOKIES_VERSION = 1;
